/** * * Asynchronously loads the component for
CourseDetails
* */ import { lazyLoad } from 'utils/loadable';
export const CourseDetails = lazyLoad(() => import('./index'));
